import { FormattedMessage, defineMessages } from 'react-intl';
import styled from 'styled-components';

import { LabelL } from '@sorare/core/src/atoms/typography';
import { useTouchScreen } from '@sorare/core/src/hooks/device/useTouchScreen';

const messages = defineMessages({
  tapToSelect: {
    id: 'UnlockPro.tapToSelectMode',
    defaultMessage: 'Tap above to select a game mode',
  },
  clickToSelect: {
    id: 'UnlockPro.clickToSelectMode',
    defaultMessage: 'Click above to select a game mode',
  },
});

const Root = styled.div`
  padding: var(--double-unit) var(--quadruple-unit);
`;

export const TapInstructionMessage = () => {
  const isTouch = useTouchScreen();
  return (
    <Root>
      <LabelL color="var(--c-nd-600)" className="text-center" bold>
        <FormattedMessage
          {...(isTouch ? messages.tapToSelect : messages.clickToSelect)}
        />
      </LabelL>
    </Root>
  );
};
